export const MITRA_PROMO_HIGHLIGHT_KEY = 'vouchers';
export const MITRA_SUBSCRIPTION_TRANSACTION_TYPE = 'mitra-subscription';

export const CABLE_TV_TRANSACTION_TYPE = 'cable-tv';
export const TRANSACTION_NOT_FOUND_ERROR_CODE = 'TRANSACTION_TRANSACTION_NOT-FOUND';
export const TRANSACTION_NOT_FOUND_ERROR_MESSAGE = 'Nomor tidak terdaftar. Coba periksa lagi, yuk.';

export const TRANSACTION_BILL_ALREADY_PAID_ERROR_CODE = 'TRANSACTION_POSTPAID-INQUIRY_BILLS-ALREADY-PAID';
export const TRANSACTION_BILL_ALREADY_PAID_ERROR_MESSAGE = 'Tagihan tidak ditemukan atau sudah dibayar.';

export const TRANSACTION_POSTPAID_INQUIRY_BILLS_NOT_AVAILABLE_ERROR_CODE =
  'TRANSACTION_POSTPAID-INQUIRY_BILLS-NOT-AVAILABLE';

export const TRANSACTION_GENERAL_ERROR_MESSAGE = 'Terjadi kesalahan pada sistem. Silahkan coba lagi.';

export const MITRA_APPS_UPDATE_CONVERSION_CONFIG = 'mitra-apps-update-version-config';
export const PRODUCT_TYPE_CABLE_TV = 'PRODUCT_TYPE_CABLE_TV';
export const PRODUCT_TYPE_EDUCATION = 'PRODUCT_TYPE_EDUCATION';
export const PRODUCT_TYPE_TRAVEL = 'PRODUCT_TYPE_TRAVEL';
